/* eslint-disable */
<template>
  <section class='content'>
    <div class='container-fluid'>
      <div class='block-header'>
        <h2>{{ nama }}</h2>
      </div>
      <div class='row clearfix'>
        <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <div class='card'>
            <div class='header'>
              <h2>{{ id_Pengumuman != null ? 'Edit' : 'Tambah' }} {{ nama }}</h2>
            </div>
            <div class='body'>
              <form class='form-horizontal' v-on:submit.prevent='onSubmit'>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='judul'>Judul</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='judul'
                        type='text'
                        v-model='data.judul'
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class="row clearfix">
                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                    <label for="kategori">Kategori</label>
                  </div>
                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                    <div class="form-group">
                      <div class="form-line">
                        <select v-model="data.kategori" class="form-control">
                          <option disabled value="">-- Pilih Kategori --</option>
                          <option value="1">Umum</option>
                          <option value="2">Pegawai</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row clearfix">
                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                        <label for="tanggalMulai">Tanggal Mulai</label>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                        <div class="form-group">
                            <div class="form-line">
                                <flat-pickr class="form-control" id="tanggalMulai" v-model="data.tanggalMulai" :config="date"></flat-pickr>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row clearfix">
                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                        <label for="tanggalAkhir">Tanggal Akhir</label>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                        <div class="form-group">
                            <div class="form-line">
                                <flat-pickr class="form-control" id="tanggalAkhir" v-model="data.tanggalAkhir" :config="date"></flat-pickr>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='pengumuman'>Pengumuman</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <Ckeditor
                        id='pengumuman'
                        ref="ckeditor"
                        v-model='data.isi'
                        :config='config'
                        ></Ckeditor>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5'
                  >
                    <button
                      v-if='id_Pengumuman != null'
                      @click='update'
                      type='button'
                      class='btn btn-warning waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i> Edit
                    </button>
                    <button
                      v-else
                      @click='save'
                      type='button'
                      class='btn btn-primary waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i>
                      Simpan
                    </button>
                    <button
                      @click='$router.go(-1)'
                      type='button'
                      class='btn btn-danger'
                      v-waves.button
                    >
                      <i class='material-icons'>cancel</i> Batal
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import Ckeditor from 'vue-ckeditor2'
import FormLine from '@/components/FormLine.vue'
import api from '@/helper/api'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  components: { FormLine, Ckeditor, vueDropzone: vue2Dropzone },
  name: 'Pengumuman',
  data: function () {
    return {
      date: {
      dateFormat: 'd-m-Y',
      allowInput: true
      },
      config: {
        height: 300,
        filebrowserUploadUrl: api.defaults.baseURL+'/upload_image_pengumuman',
        filebrowserUploadMethod: 'xhr',
        extraPlugins: 'uploadimage,image2',
        removePlugins: 'image',
        toolbar: [
          { name: 'document', items: ['Source', '-', 'Preview'] },
          { name: 'clipboard', items: ['Undo', 'Redo'] },
          { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
          {
            name: 'basicstyles',
            items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
          },
          {
            name: 'paragraph',
            items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent']
          },
          {
            name: 'insert',
            items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar']
          }
        ]
      },
      data: {
        judul: '',
        isi: '',
        kategori: '',
        file: [],
        tanggalMulai:'',
        tanggalAkhir:''
      },
      tanggalMulai: '',
      tanggalAkhir:'',
      file: '',
      id_Pengumuman: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    }
  },
  methods: {
    save () {
      console.log("ini datanya", this.data)
      if (this.data.kategori === null || this.data.kategori === '') {
      this.$toastr.e('Kategori tidak boleh kosong!');
      return;
      }
      this.isLoading = true
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .post('/cretePengumuman', this.data)
        .then((result) => {
          if (result.data.code === 200) {
            this.$toastr.s('Tambah data berhasil')
            this.$router.replace('/main/Pengumuman/Pengumuman')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        })
        .catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
    },
    update () {
      this.isLoading = true
      console.log(this.data)
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .post('/updatePengumuman/' + this.id_Pengumuman, this.data)
        .then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/pengumuman/pengumuman' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        })
        .catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          console.log(msg)
          this.isLoading = false
        })
    }, 
    onUploadSuccess(file, response) {
      console.log("iniresponse dari dropzone",response)
      const idFile = response && response.object ? response.object.id : null;
      console.log("ini idfile",idFile);
      if(idFile){
        this.data.filePengumuman.push(
         idFile
        );
      }
      console.log("ini pengumuman",this.data.filePengumuman)
    },
    getDetail () {
      this.init = true
      console.log("ini file get data edit",this.filePengumuman)
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .get('/get_pengumuman/' + this.id_Pengumuman)
        .then((result) => {
          console.log("ini hasil get data",result)
          this.data = result.data.object
          this.data.file = (result.data.object.file || []).map(item => item.id_file)
          console.log("inir resultnya",result.data.object.file)
          this.data.kategori = result.data.object.kategori
          this.init = false
          this.data.tanggalMulai = this.$moment(result.data.object.tanggalMulai, 'YYYY-MM-DD').format('DD-MM-YYYY');
          this.data.tanggalAkhir = this.$moment(result.data.object.tanggalAkhir, 'YYYY-MM-DD').format('DD-MM-YYYY');



        })
        .catch((ex) => {
          console.error("Error getDetail:", ex)
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.init = false
        })
    },
    sendingEvent (file, xhr, formData) {
      formData.append('id_Pengumuman', parseInt(this.id_Pengumuman))
      console.log(this.id_Pengumuman)
      formData.append('id_Pengumuman', parseInt(this.id_Pengumuman))
    },
    onSubmit () {
      if (this.id_Pengumuman != null) this.update()
      else this.save()
    },
    checkRoute (route) {
      console.log(route.name)
      if (route.name === 'TambahArtikel' || route.name === 'EditArtikel') {
        this.link = 'pengumuman'
        this.nama = 'Pengumuman'
      }
    },
    vremoved (file, xhr, error) {
      console.log("ini filenya", file)
      if (!this.init) this.delete(file.name.id)
    },
    delete (id) {
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .delete('/delete_file_artikel/' + id)
        .then((result) => {
          console.log(result.data.code)
          if (result.data.code === 200) {
            this.$toastr.s('Foto berhasil dihapus')
            this.$swal.close()
          } else {
            this.$toastr.e('Gagal menghapus foto')
            this.$swal.close()
          }
        })
        .catch((e) => {
          this.$swal.close()
        })
    }
  },
  mounted () {
    this.checkRoute(this.$route)
    this.id_Pengumuman = this.$route.params.id
    if (this.id_Pengumuman != null) {
      this.getDetail()
    }
      // Tunggu CKEditor siap (delay kecil)
    this.$nextTick(() => {
    const editorInstance = this.$refs.ckeditor.instance;

    if (editorInstance) {
      editorInstance.on('fileUploadResponse', (evt) => {
        const data = evt.data;
        const xhr = data.fileLoader.xhr;
        
        console.log('File upload response:', xhr.responseText); // <-- Ini akan muncul sekarang
        const response = JSON.parse(xhr.responseText);

        console.log('Upload response:', response); // <-- Ini akan muncul sekarang
        this.data.file.push(response.id_file);

      });
    } else {
      console.warn('CKEditor instance belum tersedia');
    }
  });
  },
  watch: {
    $route (to, from) {
      this.checkRoute(to)
    },
    'data.judul'(newVal) {
    console.log('Isi judul sekarang:', newVal)
    },
    'data.kategori'(newVal) {
      console.log('Kategori dipilih:', newVal)
    },
    'data.kategori'(newVal) {
      console.log(this.fileArtikelId, newVal)
    },
    'data.content'(newVal) {
      console.log('Konten artikel berubah')
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/view/Pengumuman/Pengumuman.vue